"use client";

import { useState } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Button } from "@/src/components/ui/Button";
import { Heading, Text } from "@/src/components/ui/Typography";
import { cn } from "@/src/lib/utils";

import { expertiseItems } from "./data";
import { ExpertiseListItem } from "./ExpertiseListItem";
import { ExpertiseDetail } from "./ExpertiseDetail";
import { ExpertiseMobileRow } from "./ExpertiseMobileRow";

export function AreasOfExpertise() {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeItem = expertiseItems[activeIndex];

  return (
    <Section className="bg-white">
      <Container>
        <Heading as="h2" size="displayLG" className="max-w-150">
          Areas of Expertise
        </Heading>

        <Text size="bodyLG" className="mt-4 max-w-150 text-neutral-600">
          From first commit to production, TechEniac architect, build, and
          scales AI-SaaS products that grow with your users.
        </Text>

        <div className="mt-8">
          <Button href="/contact-us">Start a Conversation</Button>
        </div>

        {/* Desktop: list + detail side-by-side */}
        <div className="mt-16 hidden gap-12 md:grid md:grid-cols-2 md:gap-24">
          <div className="flex flex-col gap-8">
            {expertiseItems.map((item, index) => (
              <ExpertiseListItem
                key={item.number}
                number={item.number}
                title={item.title}
                active={index === activeIndex}
                onSelect={() => setActiveIndex(index)}
              />
            ))}
          </div>

          <div key={activeItem.number} className={cn("h-full animate-[fadeIn_0.3s_ease]")}>
            <ExpertiseDetail item={activeItem} />
          </div>
        </div>

        {/* Mobile: inline accordion */}
        <div className="mt-12 md:hidden">
          {expertiseItems.map((item, index) => (
            <ExpertiseMobileRow
              key={item.number}
              item={item}
              active={index === activeIndex}
              onSelect={() => setActiveIndex(index)}
            />
          ))}
        </div>
      </Container>
    </Section>
  );
}
